var render, staticRenderFns
import script from "./AirQualityHeatingTable.vue?vue&type=script&lang=js&"
export * from "./AirQualityHeatingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183c9ec6",
  null
  
)

export default component.exports